import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { clearCsrfToken } from '../../api/csrf';
import { useLogout, useLogoutAll } from '../../auth/authQueries';
import { Button, pushToast } from '../../components/ui';
import { describeDevice } from '../../lib/formatters';
import { ROUTES } from '../../lib/routes';
import { track } from '../../lib/logger';
import '../../components/account/account.css';

export default function SecurityPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const logout = useLogout();
  const logoutAll = useLogoutAll();
  const device = describeDevice();

  function endSession(): void {
    clearCsrfToken();
    queryClient.clear();
    navigate(ROUTES.login, { replace: true });
  }

  function handleLogout(): void {
    track('auth_logout_started', { route: ROUTES.security });
    logout.mutate(undefined, {
      onSuccess: endSession,
      onError: () => pushToast('Không thể đăng xuất. Vui lòng thử lại.', 'error'),
    });
  }

  function handleLogoutAll(): void {
    logoutAll.mutate(undefined, {
      onSuccess: ({ revokedSessionCount }) => {
        track('auth_logout_all_succeeded', { route: ROUTES.security });
        pushToast(`Đã đăng xuất khỏi ${revokedSessionCount} phiên.`, 'success');
        endSession();
      },
      onError: () => pushToast('Không thể đăng xuất tất cả. Vui lòng thử lại.', 'error'),
    });
  }

  const busy = logout.isPending || logoutAll.isPending;

  return (
    <div className="stack">
      <h1>Bảo mật &amp; phiên đăng nhập</h1>

      <div className="device-card">
        <div>
          <div className="device-card__title">Thiết bị hiện tại</div>
          <div className="device-card__meta">
            {device.browser} · {device.os}
          </div>
          <div className="device-card__status">
            <span className="dot dot--success" aria-hidden="true" />
            Bạn đang đăng nhập trên thiết bị này
          </div>
        </div>
        <Button
          variant="secondary"
          onClick={handleLogout}
          loading={logout.isPending}
          disabled={busy}
        >
          Đăng xuất
        </Button>
      </div>

      <div className="danger-card">
        <div>
          <div className="danger-card__title">Đăng xuất khỏi tất cả thiết bị</div>
          <div className="danger-card__desc">Kết thúc mọi phiên, kể cả thiết bị hiện tại.</div>
        </div>
        <Button
          variant="danger"
          onClick={handleLogoutAll}
          loading={logoutAll.isPending}
          disabled={busy}
        >
          Đăng xuất tất cả
        </Button>
      </div>
    </div>
  );
}
